import Axios from "axios";

export const GetStudentListBySubsidiary = async (subsidiaryId, status) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getStudentListBySubsidiary/",
            { subsidiaryId, status },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetStudentListBySubsidiaryOrNull = async (subsidiaryId, status) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getStudentListBySubsidiaryOrNull/",
            { subsidiaryId, status },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetPaymentPlanByStudent = async (student_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getPaymentPlanByStudent/",
            { student_id },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetStudentListClassesByStudent = async (student_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getStudentListClassesByStudent/",
            { student_id },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetSchoolingList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getSchoolingList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};
export const GetRelatedTypeList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getRelatedTypeList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};
export const GetAllTeacherClasses = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getAllTeacherClasses/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};

export const GetAllTeacherClassesBySubsidiary = async (subsidiary_id) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "getAllTeacherClassesBySubsidiary/", {
        subsidiary_id
    }, {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};
export const GetReceptionPeopleList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getReceptionPeopleList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};
export const GetReceptionPeopleListActive = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getReceptionPeopleListActive/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};
export const GetSurveyOptions = async (question) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "getSurveyOptions/",
        {
            survey_question_id: question
        },
        {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        });
    return res.data;
};
export const GetSubsidiaryList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getSubsidiaryList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};

//Payment Receipt
export const GetPaymentConcepts = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getPaymentConcepts/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo los conceptos de pago:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetLevelList = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "LevelsList/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetLevelListV2 = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getLevelListV2/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetCurrency = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getCurrency/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const GetAcademicCalendar = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getAcademicCalendar/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo las fechas especiales:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
}
export const GetSpecialDateList = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getSpecialDatesList/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo las fechas especiales:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
}
export const GetTeachersList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getAllTeachers/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    })
    return res.data
}
export const GetClassDayList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getClassDayList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    })
    return res.data
}
export const GetUnitList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getUnitList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    })

    return res.data
}
export const GetTypeClassList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getTypeList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    })

    return res.data
}
///POST
export const PostReceptionistInCharge = async (form) => {
    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "confirmReceptionistInChargePatch/", {
            email: form.email,
            password: form.password,
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const PostPromotionCodeClass = async (form) => {

    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postPromotionCodeClass/", {
            codePromotion: form.code,
            fk_teacher_class: form.teacherClasses
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const PostInscriptionStudentToGroup = async (group_id, student_id) => {

    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postInscriptionStudentToGroup/", {
            group_id,
            student_id
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const PostWithdrawStudent = async (student_id, group_id) => {

    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postWithdrawStudent/", {
            student_id, group_id
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const PostAddBookStock = async (book_id, stock_to_add) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "postAddBookStock/", {
            book_id, stock_to_add
        },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error al agregar libros a su stock:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};
export const PostChangeStudentGroup = async (student_id, actual_group_id, new_group_id) => {
    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postChangeStudentGroup/", {
            student_id, actual_group_id, new_group_id
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const PostAddSpecialDate = async (typeId, start_date, end_date) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "postAddSpecialDate/",
            {
                typeId,
                start_date,
                end_date: end_date || null, // Enviar null si no hay end_date
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error al agregar fecha especial:", error);
        throw error;
    }
};

export const GetPrincipalList = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getPrincipalList/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    })
    return res.data
}